import userimage from '../resources/user.png'
import '../styling/NewQuoteDetailsList.css';
import { useParams } from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useAuthContext} from "../hooks/useAuthContext"
import API_BASE_URL from '../config.js';


const NewQuoteDetailsList = () => {
    
    const { quoteId } = useParams();
    const {user} = useAuthContext();
    const[lineItems,setLineItems] = useState([]);
    const[quoteTotal,setQuoteTotal] = useState('');

    // clientInfo from quote model
    const[firstName,setFirstName] = useState('');
    const[lastName,setLastName] = useState('')
    const[message,setMessage] = useState('');
    const[clientID, setClientID] = useState('');
    //clientInfo from client model
    const[street1,setStreet1] = useState('');
    const[street2, setStreet2] = useState('');
    const[city,setCity] = useState('');
    const[state,setState] = useState('');
    const[zip, setZip] = useState('');
    const[phone, setPhone] = useState('');
    const[email,setEmail] = useState('');


    
    useEffect(() => {
        const fetchQuote = async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/quote/${quoteId}`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                setClientID(json.client.client_id);
                console.log(json.client.client_id);
                setFirstName(json.client.clientFirst);
                setLastName(json.client.clientLast);
                setMessage(json.client.clientMessage);
                setLineItems(json.lineItems);
                setQuoteTotal(json.quoteTotal);
            }     
        }
        if (user){
            fetchQuote()
        }  

      }, [])

      useEffect(() => { 

        const fetchClient = async () => {

            const response = await fetch(`${API_BASE_URL}/api/client/${clientID}`, {
                headers: {"Authorization" : `Bearer ${user.token}`}
            })

            const json = await response.json()

            if(response.ok){
                setStreet1(json.clientStreet1);
                console.log(street1)
                setStreet2(json.clientStreet2);
                setCity(json.clientCity);
                setState(json.clientState);
                setZip(json.clientZip);
                setPhone(json.clientPhone);
                setEmail(json.clientEmail);
            }
        }
        if(user && clientID){
            console.log("fired");
            fetchClient();
        }

      }, [clientID])

    return (
        <div className="newcreatequoteformcontainer2">
            <div className="newclientitle2">
                <div className="title2left">
                    <div className="newformleftcircle" id="quotecircle2">
                    <img src={userimage} alt="" />
                    </div>
                    {firstName ? <h1 className="text-3xl font-bold ml-4">Quote for: {firstName} {lastName}</h1> : <h1 className="text-3xl font-bold ml-4">Quote for: FirstName LastName</h1>}
                </div>
                <div className="title2right">
                   <div className="righthalf1">
                    <h1><b>Property address</b></h1>
                    {street1 ? <h1>{street1}</h1> : <h1>N/A</h1>}
                    {street2 ? <h1>{street2}</h1>: <h1>Street 2 : N/A</h1>}
                    {city ? <h1>{city}, {state}, {zip}</h1>: <h1>City, State, Zip</h1> }
                   </div>
                   <div className="righthalf2">
                   <h1><b>Contact Details</b></h1>
                    {phone ? <h1>{phone}</h1> : <h1>Phone Number</h1>}
                    {email ? <h1>{email}</h1> : <h1>email</h1>}
                   </div>
                </div>
                </div>
                <hr id="quotdetailshr" />
                <div className="newquoteformparams2">
                    <h1 id=""><b>Product/Service</b></h1>
                    <h1 id=""><b>Quantity</b></h1>
                    <h1 id=""><b>Unit Price</b></h1>
                    <h1 id=""><b>Line Total</b></h1>
                    
                </div>
                
                {lineItems && lineItems.map((lineItems) => {
                return(
                    <div className="itemlines2">
                    <h1 id="qd1">{lineItems.productService}</h1>
                    <h1 id="qd2">{lineItems.quantity}</h1>
                    <h1 id="qd3">${lineItems.unitPrice}</h1>
                    <h1 id="qd4">${lineItems.total}</h1>
                </div>
                )
            })
            }
                
            <div className="messageandsave2">
            {message ? <div className="newlistclientmessage">{message}</div>: <div className="newlistclientmessage">Client Message</div>}
            
            <div className="totalnsave2">
            {quoteTotal ? <h1><b>Quote total: {quoteTotal} </b></h1> : <h1><b>Quote total: N/A</b></h1> }   

            </div>
            </div>
        </div>
     );
}
 
export default NewQuoteDetailsList;